import(/* webpackMode: "eager", webpackExports: ["Desktop"] */ "/opt/build/repo/src/app/beos/Desktop.tsx");
